<template>
  <div 
    :class="{ loading: busy }">
    <div v-if="result.total_items > 0">
      <div class="result-info">
        <p>
          Showing {{ showingFrom }} - {{ showingTo }} of {{ result.total_items }} search result{{ result.total_items > 1 ? 's' : '' }}.
        </p>
      </div>
      <div class="result" :class="{ loading: busy }">
        <result-item
          v-for="(item, index) in result.items"
          :key="index"
          :item="item"
          :sat="sat">
        </result-item>
      </div>
      <pagination 
        v-if="result.total_pages > 1"
        :params="params"
        :total="result.total_pages"
        @to-page="toPage">
      </pagination>
    </div>
    <div v-else class="grid-x align-middle">
      <div class="cell shrink">
        <span 
          v-html="$icons.get('frown', 'xlarge')"
          style="margin-right: 1rem">
        </span>
      </div>
      <div class="cell auto">
        <strong>Sorry, your query did not return any results.</strong>
      </div>
    </div>
  </div>
</template>
  
<script>
import Pagination from '@/Pagination.vue'
import ResultItem from '@/ResultItem.vue';

export default { 
  name: 'SearchResults',
  components: {
    Pagination, ResultItem
  },
  props: {
    params: {
      type: Object,
      required: true
    },
    result: {
      type: Object,
      required: true
    },
    sat: {
      type: Boolean
    },
    busy: {
      type: Boolean
    }
  },
  methods: {
    toPage (page) {
      this.params.page = page
      this.$emit('search')
    }
  },
  computed: {
    showingFrom () {
      let p = this.params.page
      return ((p - 1) * this.params.items_per_page) + 1
    },
    showingTo () {
      let p = this.params.page
      if (p == this.result.total_pages) {
        return this.result.total_items
      } else {
        return (p * this.params.items_per_page)
      }
    }
  }
}
</script>
